import { render, staticRenderFns } from "./dian.vue?vue&type=template&id=f6a6cae2"
import script from "./dian.vue?vue&type=script&lang=js"
export * from "./dian.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports